import './styles.scss';

import React from 'react';
import {
  Col,
  Container, Nav, Navbar, Row
} from 'react-bootstrap';

export function Footer() {
  return (
    <Navbar bg="dark" variant="dark" sticky="bottom" fixed="bottom" className="Footer">
      <Container fluid>
        <Navbar.Brand className="ml-4">
          <img src="./Dyson_logo_white.svg" alt="Dyson Logo" width="80" />
        </Navbar.Brand>
        <Nav className="ml-auto mr-3">
          <Nav.Item>
            <Row>
              <Col className="text-light">
                {`© ${(new Date()).getFullYear()} Dyson`}
              </Col>
            </Row>
          </Nav.Item>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default Footer;
